/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneFallback from 'base/components/standalone/Fallback';

export const DynamicStandaloneFallback = StandaloneFallback;
export type DynamicStandaloneFallbackProps = PropsFromComponent<typeof StandaloneFallback>;

export const DynamicStandaloneFallbackWith = (extras: DynamicStandaloneExtras): typeof StandaloneFallback => {
    return function DynamicStandaloneFallback(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Fallback');
        return <StandaloneFallback {...mergeProps({ options: { theme } }, props)} />;
    }
}